import Api from '../services/Api';
import { ImpostoLista } from '../shared/types/impostoLista';

class ImpostoController {
  public static async consultaNBS(request?: ImpostoLista): Promise<any> {
    try {
      const response = await Api.get(`api/imposto/ConsultaNBS`, {
        params: {
          Descricao: request?.Descricao,
        },
      });
      return response?.data ?? [];
    } catch (error: any) {
      return [];
    }
  }

  public static async consultaCodigoOperacao(
    request?: ImpostoLista
  ): Promise<any> {
    try {
      const response = await Api.get(
        `api/imposto/ConsultaCodigoOperacao`,
        {
          params: {
            Descricao: request?.Descricao,
          },
        }
      );
      return response?.data ?? [];
    } catch (error: any) {
      return [];
    }
  }

  public static async consultaCodigoTributacao(
    request?: ImpostoLista
  ): Promise<any> {
    try {
      const response = await Api.get(
        `api/imposto/ConsultaCodigoTributacao`,
        {
          params: {
            Descricao: request?.Descricao,
          },
        }
      );
      return response?.data ?? [];
    } catch (error: any) {
      return [];
    }
  }
}

export default ImpostoController;
